import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { HeaderDesktop } from '../../components/header/desktop/HeaderDesktop';
import { HeaderMobile } from '../../components/header/mobile/HeaderMobile';
import Media from 'react-media';
import { Button, TextField } from '@material-ui/core';
import { CustomTable } from '../../components/custom-table/CustomTable';
import { MposWebPortalApi } from '../../services/api/MposWebPortalApi';
import { IMerchantsDto } from '../../models/MerchantsDto';
import { GoogleTagManagerService } from '../../services/analitycs/GoogleTagManagerService';
import { HTTPResponses } from '../../models/HTTPResponses';
import { MposLoader } from '../../components/loader/MposLoader';
import "./AssignApp.scss"

const AssignApp = (props: any) => {
  const [valueMerchants, setValueMerchants] = useState('');
  const [valueVatNumber, setValueVatNumber] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [activePageCta, setActivePageCta] = useState(true);
  const [activeFormCta, setActiveFormCta] = useState(true);
  const [selectedMerchants, setSelectedMerchants] = useState<string[]>([]);
  const [merchantsList, setMerchantsList] = useState<any[] | null>([]);
  const [createResult, setCreateResult] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);

  const renderDesktopHeader = () => {
    return (
      <HeaderDesktop specificPath={'/applications'} showBackText showBack showLogout={false} showTitle={true} title={props.location.state?.headerTitle} />
    );
  }

  const renderMobileHeader = () => {
    return (
      <HeaderMobile specificPath={'/applications'} showBack={true} showLogout={false} showTitle={true} title={props.location.state?.headerTitle} />
    );
  }

  const handleRefined = (values: any) => {
    return (
      values.map((value: any) => ({
        merchantId: value.merchantId,
        merchant: value.merchant,
        appCreation: moment(value.appCreation).format('DD/MM/YYYY'),
        pIva: value.pIva,
        terminalInfo: value.terminalInfo,
      }))
    );
  }

  useEffect(() => {
    setShowLoader(true);

    const payload = {
      merchantId: null,
      piva: null,
      state: 'NON ASSEGNATA',
      numElements: 999,
      numPage: 1,
      appId: null
    }

    MposWebPortalApi.getInstance()
      .searchMerchant(payload)
      .subscribe(
        (merchantsDto: IMerchantsDto) => {
          const merchants = merchantsDto && merchantsDto?.merchants !== null ? merchantsDto.merchants! : [];
          const refined = handleRefined(merchants);
          setMerchantsList(refined);
          setShowLoader(false);
        },
        (error) => {
          setMerchantsList([]);
          setShowLoader(false);
        }
      );

    GoogleTagManagerService.getInstance().pushPageEvent(
      props.location.pathname,
      props.location.state?.headerTitle,
      {}
    );
    setResetSearch(false)
  }, [resetSearch]);

  useEffect(() => {
    if (selectedMerchants.length === 0) {
      setActivePageCta(true);
    } else {
      setActivePageCta(false);
    }
  }, [selectedMerchants])

  useEffect(() => {
    if (valueMerchants !== '' || valueVatNumber !== '') {
      setActiveFormCta(false);
    } else {
      setActiveFormCta(true);
    }
  }, [valueMerchants, valueVatNumber])

  const filterMerchants = () => {
    setShowLoader(true);

    const payload = {
      merchantId: valueMerchants,
      piva: valueVatNumber,
      state: null,
      numElements: 999,
      numPage: 1,
      appId: null
    }

    MposWebPortalApi
      .getInstance()
      .searchMerchant(payload)
      .subscribe((response) => {
        if (response.merchants === null || response.merchants === undefined) {
          setMerchantsList([]);
        } else {
          const refined = handleRefined(response.merchants);
          setMerchantsList(refined);
        }
        setShowLoader(false);
      },
        (error) => {
          setMerchantsList([]);
          setShowLoader(false);
        });
  };

  const handleSelectRow = (id: string) => {
    const indexToRemove = selectedMerchants.indexOf(id);

    if (indexToRemove !== -1) {
      const updatedSelected = selectedMerchants.filter((element: string) => element !== id);
      setSelectedMerchants(updatedSelected)
    } else {
      setSelectedMerchants([...selectedMerchants, id])
    }
  }

  const handleSelectAllClick = (event: any) => {
    if (event.target.checked) {
      const allSelected: any[] = merchantsList!.length > 0 ? merchantsList!.map((n: any) => n.merchantId) : [];
      setSelectedMerchants(allSelected);
      return;
    }
    setSelectedMerchants([]);
  }

  const hendlerConfirm = (event: any) => {
    event.preventDefault();
    setShowLoader(true);

    const appName = props.location.state?.data?.appName;
    const appSite = props.location.state?.data?.appSite;

    // QUI DEVE PORTARMI SU PAG: HAI AGGIORNATO I PUNTI VENDITA
    if (props.location.state.addDelegate) {

      const payload = {
        appName: props.location.state?.appName,
        appSite: props.location.state?.appSite,
        merchants: selectedMerchants,
      }

      MposWebPortalApi.getInstance()
        .addMerchantsToApp(payload)
        .subscribe((result) => {
          if (result === HTTPResponses.OK) {
            setCreateResult(true);
            showApp();
          } else if (result === HTTPResponses.KO) {
            setCreateResult(false);
            showApp();
          }
        });

    } else if (props.location.state.createNewApp) {
      MposWebPortalApi
        .getInstance()
        .createApp(
          appName,
          selectedMerchants,
          appSite
        )
        .subscribe(
          (result) => {
            if (result === HTTPResponses.OK) {
              setCreateResult(true);
              showApp();
            } else if (result === HTTPResponses.KO) {
              setCreateResult(false);
              showApp();
            }
          }
        );
    }
  }

  const showApp = () => {
    setShowLoader(false);
    if (props.location.state.addDelegate) {
      setCreateResult((prevCreateResult) => {
        const updatedCreateResult = prevCreateResult;
        props.history.push("/result", {
          isSuccess: updatedCreateResult,
          title: `Hai aggiornato i punti vendita!`,
          message: "",
          button: "Torna alla lista applicazioni",
          data: { from: "App", operation: "updateApp" },
        });
        return updatedCreateResult;
      });
    } else {
      setCreateResult((prevCreateResult) => {
        const updatedCreateResult = prevCreateResult;
        props.history.push("/result", {
          isSuccess: updatedCreateResult,
          title: `Hai creato un’applicazione!`,
          message: "",
          button: "Torna alla lista applicazioni",
          data: { from: "App", operation: "createApp" },
        });
        return updatedCreateResult;
      });
    }
  };

  return (
    <>
      {
        // @ts-ignore
        <MposLoader show={showLoader} />
      }
      <div id="main-container-assign-app">
        <Media query="(max-width: 1064px)" render={() => renderMobileHeader()} />
        <Media query="(min-width: 1065px)" render={() => renderDesktopHeader()} />
        <div className="assign-app-container">
          <p className="assign-app-title">
            {props.location.state?.createNewApp ? (
              'Seleziona i punti vendita per utilizzare i relativi TID tramite le chiavi della specifica applicazione')
              : props.location.state?.title}</p>
          <div className="assign-app-filter-container">
            <div className="assign-app-filter-field">
              <TextField
                id="assign-app-field-merchant"
                label="Merchant"
                value={valueMerchants}
                onChange={(e) => {
                  const val = e.target.value
                  setValueMerchants(val);
                  val === '' && valueVatNumber === '' && setResetSearch(true)
                }}
              />
            </div>
            <div className="assign-app-filter-field">
              <TextField
                id="assign-app-field-vat-number"
                label="P.IVA"
                value={valueVatNumber}
                onChange={(e) => {
                  const val = e.target.value
                  setValueVatNumber(val);
                  valueMerchants === '' && val === '' && setResetSearch(true)
                }}
              />
            </div>
            <div className="assign-app-filter-field">
              <Button
                id="merchant-search-button"
                disabled={activeFormCta}
                type="submit"
                onClick={() => filterMerchants()}
              >
                CERCA
              </Button>
            </div>
          </div>
          <div className="assign-app-table">
            <CustomTable
              data={merchantsList}
              rowsPerPage={10}
              isCollapsable
              collapseLabel="Elenco TID"
              headerLabels={['MERCHANT ID', 'MERCHANT', 'DATA CREAZIONE', 'P.IVA', '']}
              isCheckable
              numSelected={selectedMerchants.length}
              rowCount={merchantsList!.length > 0 ? merchantsList!.length : 0}
              onSelectAllClick={(event: any) => handleSelectAllClick(event)}
              onSelectRow={(event: any, id: string) => handleSelectRow(id)}
              rowSelected={selectedMerchants}
            />
          </div>
          <div className="form-elements">
            <Button disabled={activePageCta} onClick={hendlerConfirm} className={"change-password-submit-button"} type={"submit"} >
              CONFERMA
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignApp